import React, {Fragment} from "react";
import BasicSelect from "../../../common/BasicSelect";

export default function RatesSelect({ name, label, placeholder, defaultValue, handleChange, input, meta, options, meta:{touched, error, warning}}) {
    return(
        <Fragment>
            <BasicSelect
                name={name}
                label={label}
                placeholder={placeholder}
                options={options}
                onChange={handleChange}
                input={input}
                defaultValue={defaultValue}
                meta={meta}
            />
            <div>
                <span className="font-12 color-danger">{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</span>
            </div>
        </Fragment>
    )
}